// extracted by mini-css-extract-plugin
export var chevron = "_lr-4";
export var chevronExpanded = "_lr-5";
export var row = "_lr-0";
export var rowBody = "_lr-6";
export var rowDescription = "_lr-7";
export var rowHeader = "_lr-1";
export var rowTitle = "_lr-2";
export var rowTitleComplete = "_lr-3";